import React, { useState } from 'react';

const GraftCalculator: React.FC = () => {
  const [areas, setAreas] = useState({
    1: false, 2: false, 3: false, 4: false, 5: false,
    51: false, 6: false, 7: false, 8: false, 9: false, 10: false,
  });

  const calculateGrafts = () => {
    const graftCounts: { [key: number]: number } = {
      1: 650,  // Zone 1 (Hairline): average of 500-800
      2: 1000, // Zone 2 (Front): average of 800-1200
      3: 1250, // Zone 3 (Mid-scalp/front): average of 1000-1500
      4: 1400, // Zone 4 (Top/mid-scalp): average of 1200-1600
      5: 1150, // Zone 5 (Crown/front vertex): average of 800-1500
      6: 1750, // Zone 6 (Mid vertex): average of 1500-2000
      7: 1400, // Zone 7 (Back vertex/crown): average of 2000-2500
      8: 1250, // Assuming this is part of Zone 3
      9: 1150, // Assuming this is part of Zone 5
      10: 2250, // Assuming this is part of Zone 4
      51: 650, // Assuming this is the same as Zone 1
    };

    return Object.entries(areas).reduce((total, [key, value]) => {
      if (value && graftCounts[Number(key)]) {
        total += graftCounts[Number(key)];
      }
      return total;
    }, 0);
  };

  return (
    <section className="my-16 max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8 border border-gray-200">
      <h2 className="text-4xl font-bold text-center mb-8 text-gray-800">Hair Transplant Graft Calculator</h2>
      <div className="space-y-6 text-center mb-10">
        <p className="text-xl text-gray-600">
          Curious about your hair transplant needs? Use our interactive Norwood Scale-based calculator for a quick estimate.
        </p>
        <p className="text-md text-gray-500 italic">
          Remember: This is just a starting point. Individual needs may vary.
        </p>
      </div>
      
      <div className="flex justify-center flex-wrap gap-8 mb-10">
        {/* Left view */}
        <div className="relative w-[400px] h-[400px]">
          <div className="absolute z-10">
            <img src="/consultation/head-left-nr.png" useMap="#head_left" alt="Head diagram - Left view" />
          </div>
          {Object.entries(areas).map(([key, value]) => (
            value && (
              <div key={key} className="absolute inset-0">
                <img
                  src={`/consultation/head-left-${key.padStart(2, '0')}.png`}
                  alt={`Area ${key}`}
                  useMap="#head_left"
                />
              </div>
            )
          ))}
          <img src="/consultation/head-left-00.png" useMap="#head_left" alt="Head base - Left view" />
          <map name="head_left">
            <area
              shape="poly"
              alt=""
              coords="224,52, 228,57, 241,75, 229,77, 220,73, 214,67, 213,66, 209,60, 208,50, 212,41, 224,52"
              onClick={() => setAreas(prev => ({ ...prev, 51: !prev[51] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="197,202, 201,196, 203,194, 206,190, 216,199, 225,207, 233,213, 227,229, 212,211, 197,202"
              onClick={() => setAreas(prev => ({ ...prev, 9: !prev[9] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="257,130, 257,131, 257,139, 254,154, 234,143, 230,136, 222,118, 234,123, 247,126, 248,126, 256,127, 257,130"
              onClick={() => setAreas(prev => ({ ...prev, 7: !prev[7] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="239,197, 236,206, 235,208, 227,202, 219,195, 209,187, 214,180, 215,172, 215,162, 215,156, 211,149, 200,141, 200,141, 188,143, 179,150, 174,160, 168,161, 162,162, 162,162, 162,160, 162,159, 160,154, 157,146, 153,140, 149,135, 145,129, 154,115, 162,107, 165,105, 173,101, 181,103, 192,110, 202,118, 209,125, 213,130, 223,140, 237,151, 253,159, 252,162, 246,181, 239,197"
              onClick={() => setAreas(prev => ({ ...prev, 10: !prev[10] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="59,74, 60,74, 59,73, 70,68, 83,70, 101,65, 114,60, 131,59, 143,58, 156,55, 157,55, 162,56, 166,57, 166,81, 161,84, 159,85, 156,76, 148,72, 136,72, 126,74, 126,74, 115,77, 101,81, 88,84, 75,85, 68,84, 61,79, 56,76, 59,74"
              onClick={() => setAreas(prev => ({ ...prev, 2: !prev[2] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="83,56, 92,46, 108,36, 127,28, 150,25, 150,26, 158,36, 165,51, 157,50, 155,51, 143,53, 131,54, 122,54, 109,56, 98,60, 87,65, 75,64, 83,56"
              onClick={() => setAreas(prev => ({ ...prev, 3: !prev[3] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="197,34, 192,58, 187,74, 181,75, 179,76, 172,78, 171,55, 165,37, 157,26, 160,26, 181,29, 197,34"
              onClick={() => setAreas(prev => ({ ...prev, 4: !prev[4] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="217,111, 212,105, 203,91, 203,90, 216,96, 234,99, 250,95, 255,122, 249,121, 248,121, 237,118, 225,114, 217,111"
              onClick={() => setAreas(prev => ({ ...prev, 6: !prev[6] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="201,84, 197,78, 192,74, 197,58, 202,36, 207,38, 203,50, 205,61, 209,69, 211,71, 219,78, 232,82, 244,79, 249,90, 233,94, 217,91, 204,85, 201,84"
              onClick={() => setAreas(prev => ({ ...prev, 5: !prev[5] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="142,123, 143,116, 146,106, 152,98, 157,93, 164,88, 173,83, 181,81, 183,80, 189,79, 193,81, 197,89, 199,93, 207,107, 215,115, 215,115, 219,124, 224,134, 216,125, 213,122, 205,115, 194,106, 184,98, 173,96, 163,100, 158,103, 151,111, 142,123"
              onClick={() => setAreas(prev => ({ ...prev, 8: !prev[8] }))}
            />
            <area
              shape="poly"
              alt=""
              coords="155,88, 148,94, 147,95, 142,84, 133,77, 147,77, 153,80, 154,88, 155,88"
              onClick={() => setAreas(prev => ({ ...prev, 1: !prev[1] }))}
            />
          </map>
        </div>

        {/* Add Back and Top views here if needed */}
      </div>

      

      
      <p className="text-center mt-10 text-3xl font-semibold text-blue-600">
        Estimated grafts needed: <span className="text-4xl">{calculateGrafts()}</span>
      </p>
      
      <div className="mt-10 bg-gray-100 p-8 rounded-lg shadow-inner">
        <h3 className="text-2xl font-semibold mb-4 text-center text-gray-800">Get a Precise Assessment</h3>
        <p className="text-center mb-6 text-lg text-gray-600">
          For a personalized evaluation, send your scalp photos from multiple angles:
        </p>
        <div className="flex justify-center space-x-4">
          <a 
            href="https://www.welfareabroad.com/#contact-us" 
            className="bg-blue-600 text-white px-8 py-4 rounded-full hover:bg-blue-700 transition duration-300 text-lg font-semibold shadow-md"
          >
            Contact Form
          </a>
          <a 
            href="https://wa.me/447503753001" 
            className="bg-green-600 text-white px-8 py-4 rounded-full hover:bg-green-700 transition duration-300 flex items-center text-lg font-semibold shadow-md"
          >
            <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default GraftCalculator;
